import { SET_PAGE_CACHE } from '../actionTypes/CacheActionTypes';

/**
 * Reducer to handle the application cache settings
 */

export default function CacheReducer(state = {}, action) {
    switch (action.type) {
        case SET_PAGE_CACHE:
            return action.cache;
        default:
            return state;
    }
}
